/*
 * Copyright (c) Schrocken Inc.
 * Author: Nitin
 * File Description: Actions file for authentication
 */
import axios from "axios";

import {
  appUrl,
  associateCMOsRoles,
  associateWarehouseRoles,
  smlUrl,
} from "../../utils/config";

import {
  USER_LOGIN,
  ADMIN_SIGNUP,
  INVITED_USER,
  PASSWORD_CRITERIA,
} from "./types";

// Import redirect logic
import { redirectUser } from "./redirectUser";
import jwt_decode from "jwt-decode";

//USER LOGIN
export const loginUser =
  (signInData, history, sessionLogin, returnUrl) => (dispatch) => {
    axios
      .post(`${smlUrl}/auth/userSignIn`, signInData)
      .then((res) => {
        if (res.data.status === true) {
          redirectUser(res.data, history, sessionLogin, returnUrl);
        }
      })
      .catch((err) => {
        console.log("login err", err);
        if (err.response.status === 401 || err.response.status === 400) {
          dispatch({
            type: USER_LOGIN,
            payload: err.response.data,
          });
        }
      });
  };

//Azure User Login
export const azureUserLogin = (data, history) => (dispatch) => {
  axios
    .post(`${smlUrl}/user/azureADSignIn`, data)
    .then((res) => {
      if (res.data.status === true) {
        redirectUser(res.data, history);
      }
    })
    .catch((err) => {
      dispatch({
        type: INVITED_USER,
        payload: err.response.data,
      });
    });
};

//Azure user confirm Sign Up details
export const verifyAzureSignUp = (data, history, signUpToken) => (dispatch) => {
  console.log("in api call");
  axios
    .post(`${smlUrl}/user/verifyAzureUser`, data)
    .then((res) => {
      if (res.data.status === true) {
        history.push(`/confirmazuresignup/${signUpToken}`);
      }
    })
    .catch((err) => {
      dispatch({
        type: INVITED_USER,
        payload: err.response.data,
      });
    });
};
// Ecosystem invitation checking
export const getSignupTokenDetails =
  (invitedUserToken, history) => (dispatch) => {
    axios
      .post(`${smlUrl}/user/verifySignupToken`, invitedUserToken)
      .then((res) => {
        if (res.data.status === true) {
          dispatch({
            type: INVITED_USER,
            payload: res.data,
          });
        }
      })
      .catch((err) => {
        if (err.response.status === 400) {
          // dispatch({
          //   type: INVITED_USER,
          //   payload: err.response.data,
          // });
          history.push("/pageNotFound");
        }
      });
  };

export const checkPasswordCriteria = (data) => (dispatch) => {
  axios
    .post(`${smlUrl}/admin/verifyUserCriteria`, data)
    .then((res) => {
      if (res.data.status === true) {
        dispatch({
          type: PASSWORD_CRITERIA,
          payload: res.data,
        });
      }
    })
    .catch((err) => {
      dispatch({
        type: PASSWORD_CRITERIA,
        payload: err.response.data,
      });
    });
};

//Join user in network
export const joinNetwork = (userData, history) => (dispatch) => {
  axios
    .post(`${smlUrl}/user/joinNetwork`, userData)
    .then((res) => {
      if (res.data.status === true) {
        console.log(res.data)
        let decoded = jwt_decode(res.data.data.authToken);
        console.log(`${appUrl}/${res.data.data.appName}/${res.data.data.network}/${res.data.data.collabType}/${res.data.data.roleName}/setupNewUserAssociations`)
        if (
          associateCMOsRoles
            .concat(associateWarehouseRoles)
            .includes(decoded.collaborator_role_id)
        ){
          console.log('Inside join associate');
          axios
            .post(
              `${appUrl}/${res.data.data.appName}/${res.data.data.network}/${res.data.data.collabType}/${res.data.data.roleName}/setupNewUserAssociations`,
              {},
              {
                headers: {
                  Authtoken: res.data.data.authToken,
                },
              }
            )
            .then((res1) => {
              if (res1.data.status) {
                redirectUser(res.data, history);
              }
            })
            .catch((err) => {
              console.log(err);
              redirectUser(res.data, history);
            });
        } else {
          console.log('Inside non associate');
          redirectUser(res.data, history);
        }
      }
    })
    .catch((err) => {
      if (err.response.status === 400) {
        dispatch({
          type: ADMIN_SIGNUP,
          payload: err.response.data,
        });
      }
    });
};

//Join Azure user in network
export const joinNetworkAzureUser = (userData, history) => (dispatch) => {
  axios
    .post(`${smlUrl}/user/joinAzureAD`, userData)
    .then((res) => {
      if (res.data.status === true) {
        let decoded = jwt_decode(res.data.data.authToken);
        if (
          associateCMOsRoles
            .concat(associateWarehouseRoles)
            .includes(decoded.collaborator_role_id)
        ) {
          axios
            .post(
              `${appUrl}/${res.data.data.appName}/${res.data.data.network}/${res.data.data.collabType}/${res.data.data.roleName}/setupNewUserAssociations`,
              {},
              {
                headers: {
                  Authtoken: res.data.data.authToken,
                },
              }
            )
            .then((res1) => {
              if (res1.data.status) {
                redirectUser(res.data, history);
              }
            })
            .catch((err) => {
              console.log(err);
              redirectUser(res.data, history);
            });
        } else {
          redirectUser(res.data, history);
        }
      }
    })
    .catch((err) => {
      if (err.response.status === 400) {
        dispatch({
          type: ADMIN_SIGNUP,
          payload: err.response.data,
        });
      }
    });
};
